import { Translate as t } from '../../config/Translate';

export const AdminUserListHeader = [
	{ name: 'adminType', label: t('user.field.authority') },
	{ name: 'adminid', label: t('auth.field.loginId') },
	{ name: 'setname', label: t('common.field.name') },
	{ name: 'function', label: t('user.field.role') },
	{ name: 'country', label: t('common.field.country') },
	{ name: 'companyInfo.name', label: t('user.type.operator') },
	{ name: 'email', label: t('common.field.email') },
	{ name: 'isEmail', label: t('notification.label.receiveEmail'), type: "TF"},
	{ name: 'isTypeChange', label: t('product.label.typeChange'), type: "TF"},
	// FEAT-025 SPEC-RG-03 — 딜러 유형 (read-only). 편집은 AdminUserEditInfo 에서.
	{ name: 'dealerType', label: t('license.field.dealerType') },
];
export const AdminCompanyListHeader = [
	{ name: 'country', label: '', showtype: "ONLYFLAG", style: { width: 24 } },
	{ name: 'name', label: t('common.field.name') },
	{ name: 'org', label: t('company.label.organization') },
	{ name: 'parentName', label: t('company.field.parentCompany') },
	{ name: 'contactEmail', label: t('common.field.email') },
	{ name: 'contactTel', label: t('common.field.tel') },
	{ name: 'contactHp', label: t('common.field.mobile') },
	{ name: 'address', label: t('common.field.address') },
];
export const AdminProductListHeader = [
	{ name: 'sn', label: t('product.field.sn') },
	{ name: 'site.sitename', label: t('site.field.siteName'), link: '/Admin/AdminSiteInfo', linkdata: 'site.siteId' },
	{ name: 'model', label: t('product.field.model') },
	{ name: 'cnt_acquisitions', label: t('product.label.acquisition') },
	{ name: 'cnt_errs', label: t('common.label.error') },
	{ name: 'shipmentdate', label: t('product.field.shipmentDate'), type: "DTONLY" },
	{ name: 'installedDate', label: t('installation.field.installedDate'), type: "DTONLY" },
	{ name: 'extradata.released', label: t('product.field.releasedDate'), type: "DTONLY" },
	{ name: 'prdtype', label: t('product.field.productType'), type: "PRDTYPE" },
];
export const AdminProductQCListHeader = [
	{ name: 'timestamp', label: 'Time', type: "DT" },
	{ name: 'cnr', label: 'CNR', min: "cnrmin", max: "cnrmax", type: "PASSFAIL" },
	{ name: 'contrast', label: 'Contrast', min: "contrastmin", max: "contrastmax", type: "PASSFAIL" },
	{ name: 'nyquist', label: 'Nyquist', min: "nyquistmine", max: "nyquistmaxe", type: "PASSFAIL" },
	{ name: 'homogeneity', label: 'Homogeneity', min: "homogeneitymin", max: "homogeneitymax", type: "PASSFAIL" },
	{ name: 'noise', label: 'Noise', min: "noisemin", max: "noisemax", type: "PASSFAIL" },
	{ name: 'ctair', label: 'CTAir', min: "ctairmin", max: "ctairmax", type: "PASSFAIL" },
	{ name: 'ctpmma', label: 'CTPMMA', min: "ctpmmamin", max: "ctpmmamax", type: "PASSFAIL" },
	{ name: 'ctpvc', label: 'CTPVC', min: "ctpvcmin", max: "ctpvcmax", type: "PASSFAIL" },
	{ name: 'mtf10', label: 'MTF10', min: "mtf10min", max: "mtf10max", type: "PASSFAIL" },
	{ name: 'mtf50', label: 'MTF50', min: "mtf50min", max: "mtf50max", type: "PASSFAIL" },
	{ name: 'ai', label: 'AI', min: "aimine", max: "aimaxe", type: "PASSFAIL" },
];
export const AdminProductACQListHeader = [
	{ name: 'activationTime', label: 'Activation Time', type: "DT" },
	{ name: 'confirm', label: 'Confirm' },
	{ name: 'modality', label: 'Modality' },
	{ name: 'protocol', label: 'Protocol' },
	{ name: 'description', label: 'Description' },
	{ name: 'timestamp', label: 'Time', type: "DT" },
];
export const AdminProductWarantyListHeader = [
	{ name: 'timestamp', label: 'Time', type: "DT" },
	{ name: 'user', label: 'User' },
	{ name: 'content', label: 'Content' },
	{ name: 'installedWarranty', label: 'Installed Warranty' },
	{ name: 'cbctDetector', label: 'CBCT' },
	{ name: 'panoDetector', label: 'Pano' },
	{ name: 'cephDecector', label: 'Ceph' },
	{ name: 'xrayGenerator', label: 'Xray' },
	{ name: 'description', label: 'Description' },
];
export const AdminProductWarantyAllTypeListHeader = [
	{ name: 'timestamp', label: 'Time', type: "DT" },
	{ name: 'type', label: 'Type' },
	{ name: 'user', label: 'User' },
	{ name: 'content', label: 'Content' },
	{ name: 'installedWarranty', label: 'Installed Warranty' },
	{ name: 'cbctDetector', label: 'CBCT' },
	{ name: 'panoDetector', label: 'Pano' },
	{ name: 'cephDecector', label: 'Ceph' },
	{ name: 'xrayGenerator', label: 'Xray' },
	{ name: 'description', label: 'Description' },
];
export const AdminErrorListHeader = [
	{ name: 'errs.priority', label: t('service.field.priority'), type: 'PRIORITY', options: { editable: false } },
	{ name: 'errs.code', label: t('common.field.code') },
	{ name: 'sn', label: t('product.field.sn') },
	{ name: 'site.sitename', label: t('site.field.siteName'), link: '/Admin/AdminSiteInfo', linkdata: 'site.siteId' },
	{ name: 'model', label: t('product.field.model') },
	{ name: 'errs.begin', label: t('common.button.begin'), type: "DT" },
	{ name: 'errs.description', label: t('common.field.description') },
	{ name: 'errs.emsaction', label: t('service.field.pointOfOccur') },
	{ name: 'errs.timestamp', label: t('common.status.registered'), type: "DT" },
	{ name: 'mailMutedLabel', label: t('notification.email.alert') || 'Mail Alert' },
];
export const AdminProductErrorListHeader = [
	{ name: 'code', label: 'Code', link: '/Admin/AdminErrorCodeInfo', linkdata: 'code' },
	{ name: 'closer', label: 'Closer' },
	{ name: 'begin', label: 'Begin', type: "DT" },
	{ name: 'duration', label: 'Duration', type: "SPAN" },
	{ name: 'note', label: 'Note' },
	{ name: 'description', label: 'Description' },
	{ name: 'emsaction', label: 'Action' },
	{ name: 'timestamp', label: 'Time', type: "DT" },
	{ name: 'logRequested', label: 'Log Requested', type: "DT" },
	{
		name: 'addservicebutton',
		type: 'BUTTON',
		options: {
			title: 'Add Service',
			linkPath: '/Admin/AdminServiceAdd',
			paramType: 'param', //param / querystring
			paramRefer: 'PRODUCTERROR',
		},
	},
	{
		name: 'requestlogbutton',
		type: 'EMSLOGBUTTON',
		rederType: 'EMSLOGBUTTON',
		options: {
			title: 'Request Log',
			paramType: 'EMSLOGBUTTON'
		},
		ifshowKeyNull: 'emsrequestlog',
		ifnotshowText: 'Requested',
	},
];

export const AdminProductErrorListHeader2 = [
	{ name: 'code', label: t('product.field.errorCode') },
	{ name: 'definition', label: 'Definition' },
	{ name: 'begin', label: 'Begin', type: "DT" },
	{ name: 'status', label: t('common.label.status') },
	{ name: 'duration', label: t('common.field.duration') },
	{
		name: 'addservicebutton',
		type: 'BUTTON',
		options: {
			title: 'Add Service',
			linkPath: '/Admin/AdminServiceAdd',
			paramType: 'param',
			paramRefer: 'PRODUCTERROR',
		},
	}

];

export const AdminProductSiteHistory = [
	{ name: 'productUpdateDate', label: 'Time' },
	{ name: 'sitename', label: 'Site', link: '/Admin/AdminSiteInfo', linkdata: 'siteId' },
];
export const ErrorCodeListHeader = [
	{ name: 'errorCode', label: t('product.field.errorCode'), style: { width: 120 } },
	{ name: 'language', label: t('common.field.language') },
	{ name: 'model', label: t('product.field.model'), type : 'TAG' },
];
export const ErrorCodeModelListHeader = [
	{
		name: 'errorCode', label: 'Error Code', type: 'CALLBACK_BUTTON',
		options: {
			title: 'errorCode',
			//linkPath: '/Admin/AdminServiceExportCSR',
			paramType: 'callback'
		},
		align: "text-center"
	},

	{ name: 'model', label: t('product.field.model'), type : 'TAG' },
]
export const RayCodeListHeader = [
	{ name: 'type', label: t('common.field.type') },
	{ name: 'sortnumber', label: t('common.button.sort') },
	{ name: 'group', label: t('common.label.group') },
	{ name: 'code', label: t('common.field.code') },
	{ name: 'name', label: t('common.field.name') },
	{ name: 'alias', label: 'Assign', type: "TAG", align: "text-left" },
	{ name: 'category', label: t('common.label.category') },
	{ name: 'isbuiltin', label: t('product.label.builtIn'), type: "TF", align: "text-center" },
];
export const CustomFieldListHeader = [
	{ name: 'code', label: t('common.field.code') },
	{ name: 'title', label: t('common.field.title') },
	{ name: 'group', label: t('common.label.group'), type: "TAG", align: "text-left" },
	{ name: 'valuetype', label: t('common.button.typeValue') },
];
export const SiteListHeader = [
	{ name: 'sitename', label: t('site.title'), type: 'TITLE' },
	{ name: 'customername', label: t('common.label.customer'), insortable: true, type: "SITEFIRSTLAST" },
	{ name: 'sns', label: t('product.title'), arraylink: '/Admin/AdminProductInfo', type: 'ARRAYLINK', maxShow: 2 },
	{ name: 'company.name', label: t('common.label.company'), style: { width: 100 } },
	{ name: 'country', label: t('common.field.country'), insortable: true },
	{ name: 'address', label: t('common.field.address'), insortable: true, type: "SITEADDR" },
	{ name: 'email', label: t('common.field.email'), insortable: true, type: "SITEEMAIL" },
	{ name: 'createDate', label: t('common.status.registered'), type: "DT" },
];
export const InstallationListHeader = [
	{ name: 'isSubmit', label: t('common.label.status'), itemlabel: "reportstatus", type: "TF", align: "text-center", style: { width: 32 } },
	{ name: 'site.country', label: t('common.field.country'), type: "COUNTRY" },
	{ name: 'operator', label: t('user.type.operator') },
	{ name: 'sn', label: t('product.field.sn') },
	{ name: 'site.sitename', label: t('site.title') },
	{ name: 'product.model', label: t('product.field.model') },
	{ name: 'product.option', label: t('common.label.option') },
	{ name: 'installationStep', label: t('common.label.progress'), type: "PROGRESS", max: 8, align: "text-center", itemlabel: "report", modifylink: "/Installation/", itemlink: "/Admin/AdminInstallationInfo/", itemlinkkey: "_id", itemview: "isSubmit", style: { width: 200 } },
	{ name: 'createDate', label: t('common.status.registered'), type: "DT" },
];
export const SiteSurveyListHeader = [
	{ name: 'isSubmit', label: t('common.label.status'), itemlabel: "reportstatus", type: "TF", align: "text-center", style: { width: 32 } },
	{ name: 'siteCountry', label: t('common.field.country'), type: "COUNTRY" },
	{ name: 'operator', label: t('user.type.operator') },
	{ name: 'siteSitename', label: t('site.title') },
	{ name: 'model', label: t('product.field.model') },
	{ name: 'option', label: t('common.label.option') },
	{ name: 'siteSurveyStep', label: t('common.label.progress'), type: "PROGRESS", max: 6, align: "text-center", itemlabel: "report", modifylink: "/SiteSurvey/", itemlink: "/Admin/AdminSiteSurveyInfo/", itemlinkkey: "_id", itemview: "isSubmit", style: { width: 200 } },
	{ name: 'createDate', label: t('common.status.registered'), type: "DT" },
];
export const AdminServiceAdminListHeader = [
	{ name: 'ticketNationCode', label: t('common.field.country') },
	{ name: 'ticketKey', label: t('service.field.ticketNumber'), link: '/Admin/AdminService', linkdata: 'ticketKey' },
	{ name: 'summary', label: t('common.label.summary') },
	{ name: 'sn', label: t('product.field.sn'), link: '/Admin/AdminProductInfo', linkdata: 'sn' },
	{ name: 'errorCode', label: t('product.field.errorCode'), link: '/Admin/AdminErrorCodeInfo', linkdata: 'errorCode' },
	{ name: 'status', label: t('common.label.status'), type: "STATUS" },
	{ name: 'assignee', label: t('common.label.assignee') },
	{ name: 'creator', label: t('common.label.reporter') },
	{ name: 'createDate', label: t('common.field.createdDate'), type: "DT" },
	{ name: 'closedDate', label: t('common.status.closed'), type: "DT" },
	{ name: 'updateDate', label: 'UPDATED', type: "DT" },
];

export const AdminServiceAdminListHeader2 = [
	{ name: 'status', label: t('common.label.status'), type: "STATUS" },
	{ name: 'ticketKey', label: t('service.field.ticketNumber') },
	{ name: 'errorCode', label: t('product.field.errorCode'), link: '/Admin/AdminErrorCodeInfo', linkdata: 'errorCode' },
	{ name: 'summary', label: t('common.field.subject') },
	{ name: 'replacements', label: t('service.label.partReplaced'), type: 'ARRAYLIST' },
	{ name: 'createDate', label: t('common.field.reportDate'), type: "DT" },
	{ name: 'closedDate', label: t('common.status.closed'), type: "DT" },
	{ name: 'warrantyInOut', label: t('warranty.label.warrantyInOut') },
	{ name: 'creator', label: t('common.status.submitted') },
	{ name: 'assignee', label: t('common.label.assignee') },
];

export const AdminServiceListHeader = [
	{ name: 'status', label: t('common.label.status'), type: 'STATUS' },
	{ name: 'priority', label: t('service.field.priority'), type: 'PRIORITY' },
	{ name: 'ticketKey', label: t('service.field.ticketNumber'), link: '/Admin/AdminService', linkdata: 'ticketKey' },
	{ name: 'companyId', label: t('common.label.company') },
	{ name: 'sn', label: t('product.field.sn') },
	{ name: 'site.sitename', label: t('site.field.siteName'), link: '/Admin/AdminSiteInfo', linkdata: 'site.siteId' },
	{ name: 'model', label: t('product.field.model') },
	{ name: 'option', label: t('common.label.option') },
	{ name: 'installedDate', label: t('common.status.installed'), type: 'DT' },
	{ name: 'category', label: t('service.field.claimCategory') },
	{ name: 'categoryDetail', label: t('service.field.serviceCategory') },
	{ name: 'summary', label: t('common.field.subject') },
	{ name: 'lastComment', label: t('service.label.serviceHistory'), type: 'LASTCOMMENT' },
	{ name: 'replacements', label: t('service.label.partReplaced'), type: 'ARRAYLIST' },
	{ name: 'doa', label: 'DOA', type: 'DOADIM' },
	{ name: 'dim', label: 'DIM', type: 'DOADIM' },
	{ name: 'creator', label: t('common.status.submitted') },
	{ name: 'assignee', label: t('common.label.assignee') },
	{
		name: 'exportcsr', label: 'Service Report', type: 'BUTTON',
		options: {
			title: 'Export',
			linkPath: '/Admin/AdminServiceExportCSR',
			paramType: 'param'
		},
		align: "text-center"
	},
	{ name: 'closedDate', label: t('common.field.closedDate'), type: 'DT' }
];

export const ProductPartListHeader = [
	{ name: 'type', label: t('common.field.type') },
	{ name: 'code', label: t('common.field.code') },
	{ name: 'name', label: t('common.field.name') },
	{ name: 'models', label: t('product.field.model'), type: "TAG", align: "text-left" },
	{ name: 'platformInfo', label: t('product.field.platform') },
];

export const StatisticsProductHeader = [
	{ name: "sn", label: 'Serial No.' },
	{ name: 'sites.country', label: 'Country', type: 'COUNTRY' },
	{ name: 'sites.sitename', label: 'Site' },
	{ name: 'model', label: 'Model' },
	{ name: 'option', label: 'Option' },
	{ name: 'installedDate', label: 'Installed Date', type: "DT" },
	{ name: 'lastConnectedDate', label: 'Last Connected Date', type: "DT" },
];
export const StatisticsErrorHeader = [
	{ name: "sn", label: 'Serial No.' },
	{ name: 'sites.country', label: 'Country', type: 'COUNTRY' },
	{ name: 'sites.sitename', label: 'Site' },
	{ name: 'model', label: 'Model' },
	{ name: 'option', label: 'Option' },
	{ name: 'errs.code', label: 'Code' },
	{ name: 'errs.begin', label: 'Begin', type: "DT" },
	{ name: 'errs.end', label: 'End', type: "DT" },
	{ name: 'errs.closer', label: 'Closer' },
	{ name: 'errs.duration', label: 'Duration', type: "SPAN" },
	{ name: 'errs.note', label: 'Note' },
	{ name: 'errs.description', label: 'Description', type: "INFO" }
];
export const StatisticsAcquisitionHeader = [
	{ name: "sn", label: 'Serial No.' },
	{ name: 'sites.country', label: 'Country', type: 'COUNTRY' },
	{ name: 'sites.sitename', label: 'Site' },
	{ name: 'model', label: 'Model' },
	{ name: 'option', label: 'Option' },
	{ name: 'acquisitions.activationTime', label: 'Activation Time', type: "DT" },
	{ name: 'acquisitions.confirm', label: 'Confirm' },
	{ name: 'acquisitions.modality', label: 'Modality' },
	{ name: 'acquisitions.protocol', label: 'Protocol' },
	{ name: 'acquisitions.description', label: 'Description' }
];

export const RayDataWarListHeader = [
	{ name: 'companyName', label: t('user.type.operator'), align: "text-center" },
	{ name: 'categoryLabel', label: t('common.label.category'), align: "text-center" },
	{ name: 'wartype', label: t('warranty.field.warrantyType'), align: "text-center" },
	{ name: 'models', label: t('product.field.model'), type: "TAG", align: "text-left" },
	{ name: 'productWarrantyByInstalledDate', label: t('warranty.label.warrantyInstallationDate'), align: "text-center" },
	{ name: 'productWarrantyByShipmentDate', label: t('warranty.label.warrantyShipmentDate'), align: "text-center" },
	{ name: 'mainPartsWarrantyByInstalledDate', label: t('warranty.label.partWarrantyInstallationDate'), align: "text-center" },
	{ name: 'mainPartsWarrantyByShipmentDate', label: t('warranty.label.partWarrantyShipmentDate'), align: "text-center" },
];

// export const RayDataWarListHeader = [
// 	{ name: 'companyName', label: t('user.type.operator'), align: "text-center" },
// 	{ name: 'wartype', label: t('warranty.field.warrantyType'), align: "text-center" },
// 	{ name: 'models', label: t('product.field.model'), type: "TAG", align: "text-left" },
// 	{ name: 'productWarInstallMonth', label: t('warranty.label.warrantyInstallationDate'), align: "text-center" },
// 	{ name: 'productWarShipMonth', label: t('warranty.label.warrantyShipmentDate'), align: "text-center" },
// 	{ name: 'partWarInstallMonth', label: t('warranty.label.partWarrantyInstallationDate'), align: "text-center" },
// 	{ name: 'partWarShipMonth', label: t('warranty.label.partWarrantyShipmentDate'), align: "text-center" },
// 	// { name: 'active', label: t('active'), type: "TF", align: "text-center" },
// ];

export const AdminMinServiceAdminListHeader = [
	{ name: 'errorCode', label: t('product.field.errorCode'), link: '/Admin/AdminErrorCodeInfo', linkdata: 'errorCode' },
	{ name: 'status', label: t('common.label.status'), type: "STATUS" },
	{ name: 'ticketKey', label: t('service.field.ticketNumber') },
	{ name: 'summary', label: t('common.label.summary') },
	{ name: 'sn', label: t('product.field.sn'), link: '/Admin/AdminProductInfo', linkdata: 'sn' },
];

export const AdminSparePartsListHeader = [
	{ name: 'model', label: 'Model', type: 'TAG' },
	{ name: 'section', label: 'Section' },
	{ name: 'type', label: 'Type' },
	{ name: 'serviceCode', label: 'Service Code' },
	{ name: 'servicePartName', label: 'Service Part Name' },
	{ name: 'bomCode', label: 'BOM Code' },
	{ name: 'bomName', label: 'BOM Name' },
	{ name: 'rev', label: 'Rev', align: "text-center" },
	{ name: 'defaultCount', label: '적정수량', align: "text-center" },
	// { name: 'in', label: '입고', align: "text-center" },
	// { name: 'out', label: '출고', align: "text-center" },
	{ name: 'ordered', label: '주문수량', align: "text-center" },
	{ name: 'remainCount', label: '잔여수량', align: "text-center" },
];

export const AdminSparePartsStockHeader = [
	{ name: 'model', label: 'Model', type: 'TAG' },
	{ name: 'section', label: 'Section' },
	{ name: 'type', label: 'Type' },
	{ name: 'serviceCode', label: 'Service Code' },
	{ name: 'servicePartName', label: 'Service Part Name' },
	{ name: 'orderCount', label: 'Ordered' },
	{ name: 'amount', label: 'Stock' }
];

export const AdminSparePartsOrderListHeader = [
	{ name: 'orderDate', label: 'Order Date', align: 'text-center', type: 'DT' },
	{ name: 'type', label: 'Order Type', align:'text-center' },
	{ name: 'orderer', label: 'Orderer', align:'text-center' },
	{ name: 'status', label: 'Order Status', align: 'text-center' }
]

export const AdminSparePartsOrderListManagerHeader = [
	{ name: 'companyName', label: '업체명' },
	{ name: 'orderDate', label: '주문일' , type:'DT'},
	{ name: 'type', label: '구분' },
	{ name: 'orderer', label: '주문자' },
	{ name: 'status', label: '주문상태' }
]

export const getAdminSparePartsOutListHeader = () => [
	{ name: 'type', label: '유상/무상' },
	{ name: 'country', label: '국가', type: 'COUNTRY' },
	{ name: 'companyName', label: '업체' },
	{ name: 'orderStatus', label: '주문상태' },
	{ name: 'ciMailSent', label: 'CI메일발송', type: 'DT' },
	{ name: 'createDate', label: '출고일', type: 'DTONLY' },
	{ name: 'receiveDate1', label: '접수일(무상,고불처)', type: 'DTONLY' },
	{ name: 'receiveDate2', label: '접수일(자재출고)', type: 'DTONLY' },
	{ name: 'shipmentDate', label: t('product.field.shipmentDate'), type: 'DTONLY' },
	{ name: 'shipmentWorker', label: t('product.field.shipmentWorker') },
	{ name: 'productSN', label: '시리얼번호' },
	{ name: 'model', label: '모델' },
	{ name: 'installedDate', label: '설치일', type: 'DTONLY' },
	{ name: 'partsSecuringTime', label: '자재확보시간' },
	{ name: 'partsProcureDuration', label: '자재출하기간분류' },
	{ name: 'partsProcureTime', label: '자재조달시간' },
	{ name: 'partsProcureDelayReason', label: '자재조달지연사유' },
	{ name: 'forwardingAgent', label: '운송사' },
	{ name: 'invoiceNumber', label: '송장번호' },
	{ name: 'ccrNumber', label: '고불처번호' },
	{ name: 'draftNumber', label: '기안번호' },
]
